import { Badge, Card } from "../Primitives";
import { HEALTH_BANDS, toneOf } from "../crmHelpers";

/*
  Saúde da conta. O número sozinho não ajuda a agir: a tela mostra junto os motivos, que
  são o que a pessoa leva para a conversa com a cliente.
*/

export const HealthBadge = ({ score, band, title }) => {
  const meta = HEALTH_BANDS[band];
  if (!meta) return null;

  return (
    <Badge tone={meta.tone} className="whitespace-nowrap">
      <span title={title}>
        {meta.label} · {score}
      </span>
    </Badge>
  );
};

const HealthPanel = ({ usage }) => {
  if (!usage) return null;

  const meta = HEALTH_BANDS[usage.healthBand];
  if (!meta) return null;

  const reasons = usage.healthReasons || [];

  return (
    <Card className="p-4">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-sm font-bold text-slate-900">Saúde da conta</h2>
        <Badge tone={meta.tone}>{meta.label}</Badge>
      </div>

      <div className="mt-2 flex items-center gap-3">
        <span className="text-2xl font-bold leading-none text-slate-900">
          {usage.healthScore}
        </span>
        <div
          className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100"
          role="img"
          aria-label={`Saúde ${usage.healthScore} de 100`}
        >
          <div
            className={`h-full rounded-full ${toneOf(meta.tone).bar}`}
            style={{ width: `${usage.healthScore}%` }}
          />
        </div>
      </div>

      {reasons.length ? (
        <ul className="mt-3 space-y-1">
          {reasons.map((reason) => (
            <li key={reason} className="text-xs text-slate-600">
              • {reason}
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-3 text-xs text-slate-500">
          Uso estável e nenhuma pendência de cobrança.
        </p>
      )}
    </Card>
  );
};

export default HealthPanel;
